import { Routes } from "@angular/router";

import { HomeExternalDrawer } from "./state/home-external-drawer";
import { HomeExternalNavState } from "./state/home-external-nav";

const homeExternalShellProviders = [HomeExternalDrawer, HomeExternalNavState];

export const homeExternalRoutes: Routes = [
	{
		path: "",
		title: "home_external.title",
		providers: homeExternalShellProviders,
		loadComponent: () => import("./pages/home-external/home-external.component").then((c) => c.HomeExternal),
	},
	{
		path: "faqs",
		title: "home_external.faqs_page.page_title",
		providers: homeExternalShellProviders,
		loadComponent: () =>
			import("./pages/home-external-faqs-page/home-external-faqs-page.component").then((c) => c.HomeExternalFaqsPage),
	},
];
